<template>
	<section style="padding-top:0">
		<el-dialog title="选择相片" :visible="visible" :before-close="close" :show-close=false class="top-dialog"
			width="80%" top="2vh">
			<el-main v-loading="loading" style="margin:0;padding:0;height:75%;">
				<el-row class="list-top" v-for="(item0,index0) in list" :key="index0">
					<p>{{item0.date}}</p>
					<div style="display:flex;margin-top:10px;flex-wrap:wrap;">
						<div class="book-list" v-for="(item,index2) in item0.list" :key="index2">
							<el-image :src="item.path" fit="cover" lazy :class="item.checked?'img-check':''"
								:preview-src-list="[item.path]"></el-image>
							<div class="foot" @click.stop="goDetail(item,index2,index0)">
								<p>{{item.digest}}</p>
								<div class="bottom">
									<span class="span1">{{item.author?item.author.name:''}}</span>
								</div>
							</div>
							<div class="mark" v-if="is_check" @click.stop="goDetail(item,index2,index0)">
								<span :class="item.checked?'el-icon-success':'el-icon-circle-check'"
									:style="item.checked?'color:#2EB6AA;':'color:#2EB6AA;'"
									style="font-size:30px;"></span>
							</div>
						</div>
					</div>
				</el-row>
			</el-main>
			<el-row>
				<el-pagination @current-change="pageChange" :current-page="filters.page"
					layout="total, prev, pager, next, jumper" :total="totalRow"></el-pagination>
			</el-row>

			<div slot="footer" class="dialog-footer" style="display:flex;justify-content:flex-end">
				<el-upload class="upload-demo" :action="''" style="margin-right:auto" v-if="is_flag"
					:http-request="beforeUpdateFile" :show-file-list="false">
					<el-button type="primary" icon="el-icon-upload2" :loading="loading">本地上传</el-button>
				</el-upload>

				<el-button @click="close" :loading="loading">取 消</el-button>
				<el-button type="primary" :loading="loading" @click="submit()">确 定</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	// 选择相册照片的列表
	import { photo } from "@/api/server";
	import { upload } from "@/api/book";

	import { mapState } from "vuex";
	export default {
		props: {
			is_check: {
				type: Boolean,
				default: true
			},
			is_show_upload: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				list: [],
				visible: false,
				filters: {
					tag_ids: [],
					class_id: null,
					student_id: null,
					page: 1,
					size: 20
				},
				loading: false,
				list_Tags: [],
				totalRow: 0,
				check_item: null,
				is_flag: false,
			};
		},
		computed: {
			...mapState("user", ["school"])
		},
		components: {

		},

		methods: {
			beforeUpdateFile(item) {
				this.visible = false
				this.$emit('toCommit', item)
			},
			submit() {
				
				if (this.check_item) {
					let end=this.check_item.path.indexOf('?')
					if(end>-1){
						this.check_item.path=this.check_item.path.substring(0,end)
					}
					
					if (this.is_flag) {
						this.$emit('commitDeirect', this.check_item)
					} else {
						this.$emit('getCheckPhoto', this.check_item)
					}
					this.visible = false
				} else {
					this.$message({ message: "未选择相片", type: "error" });
				}
			},
			close() {
				this.visible = false
			},
			pageChange(val) {
				this.filters.page = val;
				this.getList();
			},
			sizeChange(val) {
				this.filters.page = val;
				this.getList();
			},
			goDetail(data, index, index0) {
				this.check_item = null
				this.list.forEach((z, n) => {
					z.list.forEach((r, i) => {
						if (n == index0 && i == index) {
							r.checked = true
							this.check_item = r
						} else {
							r.checked = false
						}
					})
				});

				this.list.splice(index0, 1, this.list[index0]);
			},

			getList() {
				this.loading = true;
				this.list = [];
				let param = Object.assign(this.filters, {
					start_time: null,
					end_time: null,
					author_id: null,
					author_type: null,
				});
				photo.paginateByGroup(param).then(res => {
					this.loading = false;
					if (res.data) {
						this.list = res.data.list;
						this.list.forEach(r => {
							r.list.forEach(z => {
								z.checked = false

							
							})
						})
						this.totalRow = res.data.totalRow;
					}
				});
			},

			getTags() {
				photo.getAll().then(res => {
					if (res.data) {
						this.list_Tags = res.data;
					}
				});
			},
			open(class_id, student_id, tag_ids, is_flag) {
				this.is_flag = is_flag == 1 ? true : false
				this.visible = true
				this.filters.class_id = class_id;
				this.filters.tag_ids = tag_ids && tag_ids.length > 0 ? tag_ids : null;
				this.filters.student_id = student_id;
				this.getList();
			}
		},

		mounted() {
			// this.getTags();
		}
	};
</script>

<style scoped lang="scss">
	section {
		padding: 20px 0;
	}
	.top-dialog {
		z-index: 9999 !important;
	}
	.top-dialog /deep/ .el-dialog__body {
		padding: 0 20;
	}
	.list-top {
		// display: flex;
		// flex-wrap: wrap;
		padding: 10 0;
		margin: 0;
		.book-list {
			width: 189px;
			margin: 0 20 20 0;
			position: relative;
			.el-image {
				width: 189px;
				height: 262px;
				margin-bottom: 10px;
			}

			.foot {
				line-height: 1.8;
				font-size: 14px;
				color: #333333;
				.bottom {
					display: flex;
					justify-content: space-between;
					width: 189px;
					.span1 {
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						word-break: break-all;
						flex-grow: 1;
					}
				}

				p {
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}

			.mark {
				position: absolute;
				top: 0;
				left: 0;
			}
		}
	}
	.img-check {
		border: 2px solid rgba(46, 182, 170, 1);
	}
	.set0 {
		background: #2eb6aa;
		color: #ffffff;
		border-radius: 4px;
		cursor: pointer;
	}
	.set1 {
		background: #ffffff;
		color: #999999;
		border: 1px solid #cccccc;
		border-radius: 4px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/album/selectPhoto.vue